















import { defineComponent, ref, inject, onMounted } from '@vue/composition-api'
import FileUploadList from './FileUploadList.vue'
import SelectFilePanel from './SelectFilePanel.vue'
import FileUploadProgressBar from './FileUploadProgressBar.vue'
import FileUploadStatus from './FileUploadStatus.vue'
import { Conversation, ConversationsApiKey } from '@/rest/conversations-api'

export default defineComponent({
  components: {
    FileUploadList,
    SelectFilePanel,
    FileUploadProgressBar,
    FileUploadStatus
  },

  props: {
    conversationId: String
  },

  setup(props) {
    const files = ref<File[]>([])
    const progressEvent = ref(null)
    const uploadPromise = ref<Promise<any>>(null)
    const conversation = ref<Conversation>(null)
    const conversationsApi = inject(ConversationsApiKey)

    const onFileSelected = (selectedFile: File) => {
      files.value.push(selectedFile)
    }

    onMounted(async () => {
      const response = await conversationsApi.GetConversation(
        Number.parseInt(props.conversationId)
      )
      if (response._tag === 'success') {
        conversation.value = response.data[0]
      } else {
        // eslint-disable-next-line
        console.error({ error: response.error })
      }
    })

    return {
      files,
      progressEvent,
      uploadPromise,
      onFileSelected,
      conversation
    }
  }
})
